// 2_components/tally_exit.js
// Exit-intent Tally form popup: captures first-touch UTM per session, counts
// pages and time on site, loads the Tally embed library and opens a modal on a
// desktop mouse-leave or a fast mobile scroll-up, with cookie frequency capping.

const LOG = "[tally-exit]";
const FORM_ID = "aQaQQW"; // fill in the exit-intent form ID from Tally
const MIN_TIME = 60 * 1000; // ≥60 s on the site
const MIN_PAGES = 2; // ≥2 visited pages
const COOLDOWN = 30; // days — frequency cap
let fired = false;
let pages;
let sessionStart;

export function init() {
	// Temporarily disabled — Freelo task 33073134 (keep file for later reuse).
	return;

	if (window.NAT.lang !== "cs") {
		return;
	}
	console.log(LOG, "skript inicializován na", location.pathname);

	// --- UTM capture (first-touch attribution within the session) ---
	if (!sessionStorage.getItem("natima_utm")) {
		const utmSource = new URLSearchParams(location.search).get("utm_source");
		if (utmSource) {
			sessionStorage.setItem("natima_utm", utmSource);
			console.log(LOG, "UTM zachycen z URL:", utmSource);
		} else if (document.referrer) {
			try {
				const refHost = new URL(document.referrer).hostname;
				if (refHost && refHost !== location.hostname) {
					sessionStorage.setItem("natima_utm", refHost);
					console.log(LOG, "UTM zachycen z referreru:", refHost);
				} else {
					console.log(LOG, "referrer je vlastní doména, ignoruji");
				}
			} catch (e) {
				console.log(LOG, "chyba při parsování referreru:", e);
			}
		} else {
			console.log(LOG, "žádný UTM ani referrer — bude direct");
		}
	} else {
		console.log(LOG, "UTM už v session je:", sessionStorage.getItem("natima_utm"));
	}

	// --- frequency cap: already shown / answered? ---
	const shownCookie = getCookie("natima_exit_shown");
	const answeredCookie = getCookie("natima_exit_answered");
	if (shownCookie || answeredCookie) {
		console.warn(LOG, "BLOKOVÁNO: frequency cap cookie existuje", {
			shown: shownCookie,
			answered: answeredCookie,
		});
		return;
	}
	console.log(LOG, "frequency cap OK (žádná blokující cookie)");

	// --- per-session page counter ---
	pages = parseInt(sessionStorage.getItem("natima_pages") || "0", 10) + 1;
	sessionStorage.setItem("natima_pages", pages);
	sessionStart = parseInt(sessionStorage.getItem("natima_start") || "0", 10);
	if (!sessionStart) {
		sessionStart = Date.now();
		sessionStorage.setItem("natima_start", sessionStart);
		console.log(LOG, "nová session, start =", new Date(sessionStart).toISOString());
	}
	console.log(LOG, "session stav:", {
		pages: pages,
		potreba_pages: MIN_PAGES,
		sekund_na_webu: Math.round((Date.now() - sessionStart) / 1000),
		potreba_sekund: MIN_TIME / 1000,
	});

	// --- load the Tally embed library ---
	const s = document.createElement("script");
	s.src = "https://tally.so/widgets/embed.js";
	s.onload = function () {
		console.log(LOG, "Tally embed knihovna načtena, Tally =", typeof Tally);
	};
	s.onerror = function () {
		console.error(LOG, "CHYBA: Tally embed knihovna se nepodařilo načíst");
	};
	document.head.appendChild(s);

	// --- DESKTOP: mouse-leave intent (top window edge, with a 10px tolerance) ---
	const TOP_EDGE_TOLERANCE = 15; // px — how far above/below the top edge still counts as an exit
	document.addEventListener("mouseout", function (e) {
		if (!e.relatedTarget && e.clientY <= TOP_EDGE_TOLERANCE) {
			console.log(LOG, "DESKTOP exit signál: mouseleave přes horní hranu, clientY =", e.clientY);
			openPopup();
		}
	});

	// --- MOBILE: fast scroll-up as a proxy for exit (only ≤768 px) ---
	if (window.matchMedia("(max-width: 768px)").matches) {
		let lastY = window.scrollY,
			lastT = Date.now();
		window.addEventListener(
			"scroll",
			function () {
				const now = Date.now(),
					dy = lastY - window.scrollY,
					dt = now - lastT || 1;
				const velocity = dy / dt; // px/ms upwards
				if (velocity > 1.5 && window.scrollY < 300) {
					console.log(LOG, "MOBIL exit signál: rychlý scroll nahoru, velocity =", velocity.toFixed(2));
					openPopup();
				}
				lastY = window.scrollY;
				lastT = now;
			},
			{ passive: true },
		);
		console.log(LOG, "mobilní scroll listener aktivní (šířka ≤768 px)");
	} else {
		console.log(LOG, "mobilní scroll listener přeskočen (šířka >768 px)");
	}

	console.log(LOG, "listenery (mouseout + scroll) navěšeny, čekám na exit signál");
}

// --- helper: cookie ---
function getCookie(n) {
	const m = document.cookie.match("(^|;)\\s*" + n + "\\s*=\\s*([^;]+)");
	return m ? m.pop() : "";
}

function setCookie(n, v, d) {
	const e = new Date();
	e.setTime(e.getTime() + d * 864e5);
	document.cookie = n + "=" + v + ";expires=" + e.toUTCString() + ";path=/";
}

// --- entry conditions met (time + pages)? ---
function eligible() {
	const timeOk = Date.now() - sessionStart >= MIN_TIME;
	const pagesOk = pages >= MIN_PAGES;
	if (!timeOk || !pagesOk) {
		console.log(LOG, "eligible() = false", {
			timeOk: timeOk,
			pagesOk: pagesOk,
			sekund: Math.round((Date.now() - sessionStart) / 1000),
			pages: pages,
		});
	}
	return timeOk && pagesOk;
}

// --- empty / stale cart? (adjust the selector to the Natima/Shoptet DOM) ---
function cartEmptyOrStale() {
	const c = document.querySelector("i[data-testid='headerCartCount']");
	const empty = !c || parseInt(c.textContent || "0", 10) === 0;
	if (!empty) {
		console.log(LOG, "košík není prázdný:", c.textContent);
	}
	return empty;
}

// --- open the popup ---
function openPopup() {
	console.log(LOG, "openPopup() voláno");
	if (fired) {
		console.log(LOG, "BLOKOVÁNO: popup už byl spuštěn v této session");
		return;
	}
	if (!eligible()) {
		console.log(LOG, "BLOKOVÁNO: nesplněny vstupní podmínky (čas/stránky)");
		return;
	}
	if (!cartEmptyOrStale()) {
		console.log(LOG, "BLOKOVÁNO: košík obsahuje položky");
		return;
	}
	if (document.body.classList.contains("ordering-process")) {
		console.log(LOG, "BLOKOVÁNO: body má class 'ordering-process' (checkout)");
		return;
	}
	if (typeof Tally === "undefined" || !Tally.openPopup) {
		console.warn(LOG, "BLOKOVÁNO: Tally knihovna ještě není načtená");
		return;
	}
	fired = true;
	const params = new URLSearchParams({
		context: "exit",
		last_url: location.pathname,
		session_pages: String(pages),
		time_on_site: String(Math.round((Date.now() - sessionStart) / 1000)),
		entry_source: sessionStorage.getItem("natima_utm") || "direct",
	});
	console.log(LOG, "OTEVÍRÁM POPUP, parametry:", Object.fromEntries(params));
	Tally.openPopup(FORM_ID, {
		layout: "modal",
		width: 540,
		hideTitle: true,
		hiddenFields: Object.fromEntries(params),
		onClose: function () {
			console.log(LOG, "popup zavřen bez odeslání");
			setCookie("natima_exit_shown", "1", COOLDOWN);
		},
		onSubmit: function () {
			console.log(LOG, "popup odeslán — ukládám 365denní cookie");
			setCookie("natima_exit_answered", "1", 365);
		},
	});
	setCookie("natima_exit_shown", "1", COOLDOWN);
}
